import { formatDateDDMonthShort } from "../../../helpers";

const CustomDateTick = ({ x, y, payload }: any) => {
  const formattedDate = formatDateDDMonthShort(payload.value);

  return (
    <text
      x={x}
      y={y + 13}
      textAnchor="middle"
      fill="#666"
      style={{ paddingTop: "10px" }}
    >
      {formattedDate}
    </text>
  );
};

export default CustomDateTick;
